import { UserOrdersTable } from './components';
import { useDocuments } from '../DocumentsLayout';
import { OOrder } from './components/UserOrdersTable';

const OrdersPage = () => {
  const data = useDocuments();

  return (
    <>
      {data?.currentUser?.ordersConnection.edges && (
        <UserOrdersTable
          orders={
            data.currentUser.ordersConnection.edges
              .filter((i) => !!i.node)
              .map((i) => i.node) as OOrder[]
          }
        />
      )}
    </>
  );
};

export default OrdersPage;
